import { ToastContainer } from 'react-toastify';
import { BrowserRouter } from 'react-router-dom';
import { GlobalStyle } from './styles/global';
import { Routing } from './routes';
import { AuthProvider } from './hooks/useAuth';
import ListaNotificacaoProvider from './hooks/useNotification';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ListaNotificacaoProvider>
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <Routing />
          <GlobalStyle />
        </ListaNotificacaoProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
